'use client';

import React from 'react';
import { FileManager } from '../../index';
import type { S3Object } from '../../variants/default/utils/services/fileManager';

export default function FileManagerDemo() {
    const handleFileSelect = (file: S3Object) => {
        console.log('File selected:', file);
        alert(`Đã chọn file: ${file.name}`);
    };

    return (
        <div className="min-h-screen bg-gray-100 p-8">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-4">
                        Demo File Manager S3
                    </h1>
                    <p className="text-gray-600">
                        Trình quản lý file và folder từ S3 với các tính năng:
                    </p>
                    <ul className="list-disc list-inside mt-2 text-gray-600 space-y-1">
                        <li>Xem danh sách file và folder</li>
                        <li>Navigate vào folder con</li>
                        <li>Upload file mới</li>
                        <li>Tạo folder mới</li>
                        <li>Xóa file và folder (tùy quyền)</li>
                        <li>Tìm kiếm file/folder</li>
                    </ul>
                </div>

                <FileManager 
                    namepath="viet-nam-34-tinh"
                    onFileSelect={handleFileSelect}
                    allowUpload={true}
                    allowDelete={true}
                />
            </div>
        </div>
    );
}
